<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="dialogShow"
    class="items-no-padding phone-edit sidebar-dialog">
    <div class="sidebar-content">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
        <div class="content px-6">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
          >
            <el-form-item
              :label="$t('new_email')"
              prop="newEmail"
            >
              <el-input
                v-model="form.newEmail"
                :placeholder="$t('new_email')"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              :label="$t('User.emailVerCode')"
              prop="code"
            >
              <div class="code-box pr">
                <el-input
                  v-model="form.code"
                  :placeholder="phFileter('Register.verText')"
                ></el-input>
                <div
                  class="sendMes pa theme-font"
                >
                                <span v-if="isCode"
                                      @click="getCode"
                                      class="active"
                                >{{$t('User.sendVeri')}}</span>
                  <span v-else>{{isCodeNumber}}s {{$t('User.sendDesc')}}</span>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        @click="submitHandle"
        color="primary"
        :disabled="submitLoading"
      >
        <span v-if="submitLoading"><i class="el-icon-loading"></i> </span>
        {{$t('confirm')}}
      </vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { mapGetters } from 'vuex';
import { validatEmail } from '@/utils/validate';
import { getAddPhoneVer, addPhoneSubmit } from '@/api/userCenter.js';

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: "emailEditDialog",
  components:{
    VuePerfectScrollbar
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    let _this = this;
    var validateEmailCurrent = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(_this.$t('please_input_your_email')));
      } else {
        if(!validatEmail(value)){
          callback(new Error(_this.$t('Please_enter_the_email_address_in_the_correct_format')));
        }else {
          callback();
        }
      }
    };
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      title: _this.$t('email'),

      form: {
        newEmail: '',
        code: ''
      },
      rules: {
        newEmail: [
          { required: true, message: this.$t('Partner.inputVer'), trigger: 'blur' },
          { validator: validateEmailCurrent, trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$t('Partner.inputVer'), trigger: 'blur' }
        ]
      },
      // 验证码
      loading: false,
      isCode: true,
      isCodeNumber: 60,
      codeLoading: false,
      submitLoading: false,
    }
  },

  watch: {

  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created(){
  },
  methods: {
    getCode() {
      if (this.codeLoading || !this.isCode) return;
      this.$refs.form.validateField('Email',(error) => {
        if(!error){
          let parmas = {
            newPhone: this.form.addPhones,
          };

          this.codeLoading = true;
          getAddPhoneVer(parmas).then((res) => {
            this.$message({
              message: this.$t('User.verCodeSendSuccess'),
              type: 'success'
            });
            this.isCode = false;
            this.timerOut();
            this.isCodeNumber = 60;
          }).finally(() => {
            this.codeLoading = false;
          });
        }
      })

    },
    timerOut() {
      let _this = this;
      let timer1 = setTimeout(() => {
        clearTimeout(timer1);
        if (_this.isCodeNumber > 0) {
          _this.isCodeNumber = --_this.isCodeNumber;
          _this.timerOut();
        } else {
          clearTimeout(timer1);
          this.isCode = true;
        }
      }, 1000);
    },

    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
    },
    phFileter(data){
      return this.$t(data);
    },

    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
    submitHandle(){
      if (this.submitLoading) return;
      this.$refs.form.validate((valid) => {
        if(valid){
          let parmas = {
            nationCode: this.phoneTitle,
            newPhone: this.form.addPhones,
            phoneVerCode: this.form.code,
          };
          this.submitLoading = true;
          addPhoneSubmit(parmas).then((res) => {
            this.$message({
              message: `${this.$t('editSuceess')}${this.$t('Need_to_log_in_again')}`,
              type: 'success'
            });
            this.addPhoVis = false;
            this.interfaceAjaxSuccess();
          }).finally(() => {
            this.submitLoading = false;
          });

        }else {
          console.log('error');
        }
      })
    },
    cancelHandle(){
      this.close();
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.phone-edit {
  .content {
    .text-box {
      background-color: #F8F8F8;
      padding: 10px;
      border-radius: 6px;
      .text-box-line {
        margin-bottom: 10px;
        font-size: 14px;
        .text-left {
          color: #A29FAE;
        }
        .data-right {
          color: #6E6B7B;
        }
      }
    }
    .elform {
      margin-top: 30px;
    }
    .sendMes {
      position: absolute;
      bottom: 0;
      right: 20px;
      text-align: right;
      color: $themeColor;
      span {
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="scss">
.phone-edit {
  .vs-sidebar--items {

  }
  .scroll-area--customizer {
    height: calc(100% - 5rem);
  }
  .vs-sidebar {
    position: fixed;
    z-index: 999;
    .sidebar-content {
    }
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
